import PropTypes from 'prop-types';
import * as React from 'react';
import ListItemComponent from './list-item-component';

export default class ListItemContainer extends React.Component {
  render() {
    return (
      <ListItemComponent {...this.props} />
    );
  }
}

ListItemContainer.propTypes = {
  actions: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element)
  ]),
  children: PropTypes.element,
  icon: PropTypes.string,
  id: PropTypes.string,
  loading: PropTypes.bool,
  primaryText: PropTypes.string,
  route: PropTypes.string,
  secondaryText: PropTypes.string,
};


// WEBPACK FOOTER //
// ./src/component/list/list-item/list-item-container.js